/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-script-url */
import axios from 'axios'
import { Box, Button, Image, Input, Select } from 'native-base'
import jwtDecode from 'jwt-decode'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Wrapper from '../../components/Wrapper'
import { API_URL } from '../../utils/env'
import Modal from '../../components/Modal/Modal'
import ShopCart from '../../utils/Persistence/ShopCart'
import getStatusRecurso from '../Recursos/utils/getStatusRecurso'
import EstadosRecursoEnum from '../../utils/tools/EstadosRecursoEnum'
import { Linking } from 'react-native'
import { CompactTable } from '@table-library/react-table-library/compact';
import { useSort } from "@table-library/react-table-library/sort";
import { usePagination } from '@table-library/react-table-library/pagination'
import { useTheme } from "@table-library/react-table-library/theme";
import { getTheme } from "@table-library/react-table-library/baseline";
import { validateDate } from '../../utils/functions'


function CrearReserva() {
  const navigate = useNavigate()
  const [recursos, setRecursos] = useState([])
  const [startDate, setStartDate] = useState<any>(null)
  const [endDate, setEndDate] = useState<any>(null)
  const [centros, setCentros] = useState<any>([])
  const [orderByDistance, setOrderByDistance] = useState(true)
  const [filterByCreated_at, setFilterByCreated_at] = useState<any>(null)

  const [form, setForm] = useState<{
    name: any
    fabricator: any
    model: any
    depot: any
    status: any
    serie: any
    cime: any
  }>({
    name: null,
    fabricator: null,
    model: null,
    depot: '0',
    status: '0',
    serie: null,
    cime: null,
  })
  const shopCart = new ShopCart()
  const [loading, setLoading] = useState(false)
  const status = [
    { id: 1, name: 'Disponible' },
    { id: 2, name: 'Reservada' },
    { id: 3, name: 'Incidencia' },
    { id: 4, name: 'Mantenimiento' },
    { id: 5, name: 'En traslado' },
    { id: 6, name: 'Confirmación envio' },
    { id: 8, name: 'Reservada Solicitud de envio' },
    { id: 9, name: 'Dado de baja' },
  ]

  const theme = useTheme([
    getTheme(),
    {
      HeaderRow: `
        background-color: #0d6efd;
      `,
      Row: `
        &:nth-of-type(odd) {
          background-color: #0d6efd;
        }
  
        &:nth-of-type(even) {
          background-color: #0d6efd;
        }
      `,
    },
  ]);

  const getReservasSearch = () => {
    setLoading(true)
    axios
      .post(
        `${API_URL}/resource/search`,
        {
          name: form.name,
          fabricator: form.fabricator,
          model: form.model,
          depot: parseInt(form.depot),
          status: parseInt(form.status),
          serie: form.serie,
          cime: form.cime,
          start_date: startDate,
          end_date: endDate,
        },
        {
          headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('token'),
          },
        }
      )
      .then((res) => {
        let dat: any = []
        res.data.map((recurso: any) => {
          if (filterByCreated_at){
            if (recurso.created_at.split('T')[0] !== filterByCreated_at){
              return
            }
          }
          dat.push({
            id: recurso.id,
            name: recurso.name,
            fabricator: recurso.fabricator,
            model: recurso.model,
            serie: recurso.serie,
            depot_name: recurso.depot.name,
            depot_id: recurso.depot.id,
            status: (
              <span className='font-18 text-primary fw-bold'>
                {EstadosRecursoEnum[recurso.status]}
              </span>
            ),
            reserved: `${
              !recurso?.reservation ? '' : recurso?.reservation?.user?.name
            } ${recurso.reservation ? recurso.reservation.user.name : ''}`,
            image: (
              <Image
                alt='logo'
                width={35}
                height={35}
                source={{ uri: recurso.image ? recurso.image.url : '' }}
              />
            ),
            actions: (
              <>
                <Button
                  // maxWidth={140}
                  p={2}
                  colorScheme={`warning`}
                  onPress={async () => {
                    navigate(`/recursos/ver/${recurso.id}`)
                  }}
                  size={'xs'}
                  className='btn btn-xs '
                >
                  Ver
                </Button>
              </>
            ),
            actions1: (
              <Button
                maxWidth={140}
                p={2}
                colorScheme={`${shopCart.checkItem(recurso) ? 'red' : 'green'}`}
                onPress={async () => {
                  const checkItem = shopCart.checkItem(recurso)
                  if (!checkItem) {
                    // eslint-disable-next-line no-restricted-globals
                    const confirmar = confirm(
                      '¿Desea añadir este recurso a su cesta?'
                    )
                    if (confirmar) {
                      shopCart.addItem(recurso)
                      alert('Recurso añadido a su cesta')
                    }
                  } else {
                    // eslint-disable-next-line no-restricted-globals
                    const confirmar = confirm(
                      '¿Desea eliminar este recurso de su cesta?'
                    )
                    if (confirmar) {
                      shopCart.removeItem(recurso)
                      alert('Recurso eliminado de su cesta')
                    }
                  }
                  getReservasSearch()
                }}
                className='btn btn-sm '
              >
                <i
                  className={`bx ${
                    shopCart.checkItem(recurso) ? 'bx-trash' : 'bx-cart'
                  } text-white font-14`}
                />
              </Button>
            ),
          })
        })
        setData({ nodes: dat })
        setRecursos(res.data)
      })
      .catch((err) => {
        /*
        if (__DEV__) {
          console.log(err)
        }
        */
      })
      .finally(() => {
        setLoading(false)
      })
  }
  const [data, setData] = useState<any>({ nodes: [] })
  function onPaginationChange(action: any, state: any) {
    console.log(action, state)
  }
  const pagination = usePagination(data, {
    state: {
      page: 0,
      size: 25,
    },
    onChange: onPaginationChange,
  })
  const [depots, setDepots] = useState([])
  const sort = useSort(
    data,
    {
      onChange: (column) => {
        /*if (__DEV__) {
          console.log(column)
        }
        */
      },
    },
    {
      sortFns: {
        ID: (array) => array.sort((a: any, b: any) => a.id - b.id),
        NAME: (array) =>
          array.sort((a: any, b: any) =>
            a.name.toString().localeCompare(b.name)
          ),
        FABRICATOR: (array) =>
          array.sort((a: any, b: any) => {
            if (a.fabricator === null) {
              return 1
            }
            if (b.fabricator === null) {
              return -1
            }
            return a.fabricator.toString().localeCompare(b.fabricator)
          }),
        MODEL: (array) =>
          array.sort((a: any, b: any) => {
            if (a.model === null) {
              return 1
            }
            if (b.model === null) {
              return -1
            }
            return a.model.toString().localeCompare(b.model)
          }),
        SERIE: (array) =>
          array.sort((a: any, b: any) => {
            if (a.serie === null) {
              return 1
            }
            if (b.serie === null) {
              return -1
            }
            return a.serie.toString().localeCompare(b.serie)
          }),
        DEPOT_NAME: (array) =>
          array.sort((a: any, b: any) => {
            if (a.depot_name === null) {
              return 1
            }
            if (b.depot_name === null) {
              return -1
            }
            return a.depot_name.toString().localeCompare(b.depot_name)
          }),
        RESERVED: (array) =>
          array.sort((a: any, b: any) => {
            if (a.reserved === null) {
              return 1
            }
            if (b.reserved === null) {
              return -1
            }
            return a.reserved.toString().localeCompare(b.reserved)
          }),
      },
    }
  )
  const column = [
    { label: '', renderCell: (item: any) => item.image },
    {

      renderCell: (item: any) => item.id,
      sort: { sortKey: 'ID' },
      label: 'ID',

    },
    {
      label: 'Nombre',
      renderCell: (item: any) => item.name,
      sort: { sortKey: 'NAME' },
    },
    {
      label: 'Familia',
      renderCell: (item: any) => item.fabricator,
      sort: { sortKey: 'FABRICATOR' },
    },
    {
      label: 'Modelo',
      renderCell: (item: any) => item.model,
      sort: { sortKey: 'MODEL' },
    },
    {
      label: 'N• Serie',
      renderCell: (item: any) => item.serie,
      sort: { sortKey: 'SERIE' },
    },
    {
      label: 'Almacén',
      renderCell: (item: any) => item.depot_name,
      sort: { sortKey: 'DEPOT_NAME' },
    },
    { label: 'Estado', renderCell: (item: any) => item.status, resize: true },
    {
      label: 'Reservado Por',
      renderCell: (item: any) => item.reserved,
      sort: { sortKey: 'RESERVED' },
    },
    { label: '', renderCell: (item: any) => item.actions },
    { label: '', renderCell: (item: any) => item.actions1 },
  ]
  const getDepots = async () => {
    //get depot list
    await axios
      .get(`${API_URL}/depot/all`, {
        headers: {
          Authorization: 'Bearer ' + sessionStorage.getItem('token'),
        },
      })
      .then((res) => {
        setDepots(res.data)
      })
  }

  function ordenarRecursosPorDistancia(distances: string, recursos: any[]): any[] {
    // Parsear el campo distances de string a array de objetos
    const depotDistances = JSON.parse(distances);
    
    // Crear un mapa de depot_id a distance
    const distanceMap = new Map(depotDistances.map((d: any) => [d.depot_id, d.distance]));
    
    // Ordenar los recursos usando el mapa de distancias
    return recursos.sort((a: any, b: any) => {
      const distanceA = Number(distanceMap.get(a.depot_id) ?? Number.MAX_SAFE_INTEGER);
      const distanceB = Number(distanceMap.get(b.depot_id) ?? Number.MAX_SAFE_INTEGER);
      return distanceA - distanceB;
    });
  }

  const getUserData = async () => {
    const { userData }: any = jwtDecode(sessionStorage.getItem('token')as string)
    const user= await axios.get(`${API_URL}/user/${ userData.id }`)
    console.log(user)
  }

  const getCenterUser = () => {
		axios
			.get(`${API_URL}/user/get/centers`, {
				headers: {
					Authorization: 'Bearer ' + sessionStorage.getItem('token'),
				},
			})
			.then((response) => {
				setCentros(response.data)
			})
			.catch((error) => {
				if(__DEV__){
				console.log(error);
			}
			})
	}
  useEffect(() => {
    getReservasSearch()
    getDepots()
    getCenterUser()
  }, [])

  useEffect(() => {
    if(orderByDistance){
      if(data.nodes.length > 0){
        let centerId: any = null;
        if (centros.length > 0) {
          centerId = centros[0].id;
          const depot:any = depots.find((d: any) => d.center_id === centerId as number);
          const distances = depot?.distances;
          if (distances) {
            const orderedData = ordenarRecursosPorDistancia(distances, data.nodes);
            setData({ nodes: orderedData });
          }
        }

      }
    }
  }, [orderByDistance, data.nodes, centros, depots])

  return (
    <Wrapper title='Crear Reserva' subtitle=''>
      {/* <!--start page wrapper --> */}
      <div className='page-wrapper' style={{ height: '100vh' }}>
        <div className='page-content'>
          <div className='row'>
            <div className='col-xl-12 mx-auto'>
              <h6 className='mb-0 text-uppercase'></h6>
              <Box flexDir={'row'} justifyContent={'flex-end'}>
                {/* <Input width={200} mr={4} placeholder={'Buscar...'} /> */}
                <Button onPress={() => navigate('/cesta')}
                  style={{marginRight: 10,
                    paddingHorizontal: 20,
                    paddingVertical: 10,
                    borderRadius: 8,
                    backgroundColor: '#0d6efd',
                    
                  }}	
                  >Mi Cesta</Button>
              </Box>
              <hr />
              <div className='card'>
                <div className='card-body'>
                  <h4 className='card-title text-primary fw-bold'>Buscador avanzado</h4>
                  <div className='row gap-3 py-3'>
                    <div className='col-12 col-md-3'>
                      <Input
                        onChangeText={(t) => setForm({ ...form, name: t })}
                        placeholder='Nombre'
                      />
                    </div>
                    <div className='col-12 col-md-3'>
                      <Input
                        onChangeText={(t) =>
                          setForm({ ...form, fabricator: t })
                        }
                        placeholder='Familia'
                      />
                    </div>
                    <div className='col-12 col-md-3'>
                      <Select
                        selectedValue={form.depot}
                        onValueChange={(value: string) => {
                          setForm({
                            ...form,
                            depot: value,
                          })
                        }}
                      >
                        <Select.Item label='Todos los almacenes' value='0' />
                        {depots.map((s: any) => (
                          <Select.Item key={s.id} label={s.name} value={s.id.toString()} />
                        ))}
                      </Select>
                    </div>
                    <div className='col-12 col-md-3'>
                      <Input
                        onChangeText={(t) => setForm({ ...form, serie: t })}
                        placeholder='Serie'
                      />
                    </div>
                    <div className='col-12 col-md-3'>
                      <Input
                        onChangeText={(t) => setForm({ ...form, cime: t })}
                        placeholder='Cime'
                      />
                    </div>
                    <div className='col-12 col-md-3'>
                      <Select
                        selectedValue={form.status}
                        onValueChange={(value: string) => {
                          setForm({
                            ...form,
                            status: value,
                          })
                        }}
                      >
                        <Select.Item label='Todos los estados' value='0' />
                        {status.map((s: any) => (
                          <Select.Item key={s.id} label={s.name} value={s.id.toString()} />
                        ))}
                      </Select>
                    </div>
                    <div className='col-md-3'>
                      <label className='fw-bold mb-1'>
                        Fecha de utilización:
                      </label>
                      <input
                        onChange={(event: any) => {
                          if (validateDate(event.target.value, new Date().toISOString().split("T")[0], "2050-01-01")) {
                            setStartDate(event.target.value)
                          }
                          else {
                            alert("La fecha de inicio debe ser mayor o igual a la fecha actual");
                            setStartDate('')
                          }
                        }}
                        className='form-control'
                        type='date'
                        min={new Date().toISOString().split("T")[0]} 
                        max="2050-01-01"
                      />
                    </div>
                    <div className='col-md-3'>
                      <label className='fw-bold mb-1'>
                        Fecha de finalización:
                      </label>
                      <input
                        onChange={(event: any) => {
                          if(validateDate(event.target.value, new Date().toISOString().split("T")[0], "2050-01-01"))
                            setEndDate(event.target.value)
                          else {
                            alert("La fecha de fin debe ser mayor o igual a la fecha actual");
                            setEndDate('')
                          }
                        }}
                        className='form-control'
                        type='date'
                        min={new Date().toISOString().split("T")[0]} 
                        max="2050-01-01"
                      />
                    </div>
                    <div className='col-12 col-md-3'>
                      <label className='fw-bold mb-1'>Filtrar por fecha de creación:</label>
                      <input
                        type='date'
                        onChange={(t) =>{
                          if ( validateDate(t.target.value, "2000-01-01", new Date().toISOString().split("T")[0])){
                            setFilterByCreated_at(t.target.value)
                          } else {
                            alert('Fecha no válida')
                            setFilterByCreated_at('')
                          }
                        } 
                        }
                          
                        placeholder='Fecha de creación'
                        className='form-control'
                        min="2000-01-01"
                      />
                    </div>

                    <div className='col-12 col-md-3'>
                      <label className='fw-bold mb-2'></label>
                   
                      <div className="form-check form-switch mt-2">
                        <input 
                          className="form-check-input fw-bold" 
                          type="checkbox" 
                          id="flexSwitchCheckDefault" 
                          onChange={(e) => setOrderByDistance(e.target.checked)}
                          checked={orderByDistance}
                          style={{ width: '35px', height: '20px' }}
                        />
                        <label className="fw-bold m-1" htmlFor="flexSwitchCheckDefault">Ordenar por distancia</label>
                      </div>
                    </div>
                    <div className='col-12 col-md-1'>
                      <label className='fw-bold mb-1'></label>
                      <Button onPress={() => getReservasSearch()}
                        style={{marginRight: 10,
                          paddingHorizontal: 20,
                          paddingVertical: 10,
                          borderRadius: 8,
                          backgroundColor: '#0d6efd',
                          
                        }}	
                        >
                        Buscar
                      </Button>
                    </div>
                  </div>
                  {loading ? (
                    <div className='d-flex justify-content-center text-center align-items-center'>
                      <div className='spinner-border' role='status'></div>&nbsp;
                      <span className=''>Cargando Recursos...</span>
                    </div>
                  ) : (
                    <div className='table-responsive'>
                      <CompactTable
                        theme={theme}
                        columns={column}
                        data={data}
                        sort={sort}
                        pagination={pagination}
                      />
                      <br />
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span>
                          Páginas Totales:{' '}
                          {pagination.state.getTotalPages(data.nodes)}
                        </span>

                        <span style={{ overflow: 'auto', maxWidth: 300 }}>
                          Página:{' '}
                          {pagination.state
                            .getPages(data.nodes)
                            .map((_: any, index: any) => (
                              <button
                                key={index}
                                type='button'
                                style={{
                                  fontWeight:
                                    pagination.state.page === index
                                      ? 'bold'
                                      : 'normal',
                                }}
                                onClick={() => pagination.fns.onSetPage(index)}
                              >
                                {index + 1}
                              </button>
                            ))}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--end page wrapper --> */}
    </Wrapper>
  )
}

export default CrearReserva
